import { render } from "./ProgresSiswaView.vue?vue&type=template&id=2ba1e3b8"
import script from "./ProgresSiswaView.vue?vue&type=script&lang=js"
export * from "./ProgresSiswaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__